import React, { useEffect, useState, useRef } from 'react';
import { CalendarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface DateSelectorProps {
  selectedDate: Date;
  onDateChange: (date: Date) => void;
}
export const DateSelector: React.FC<DateSelectorProps> = ({
  selectedDate,
  onDateChange
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const datePickerRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (datePickerRef.current && !datePickerRef.current.contains(event.target as Node) && !buttonRef.current?.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const formatDate = (date: Date) => {
    return date.toLocaleDateString('en-US', {
      month: 'long',
      year: 'numeric'
    });
  };
  const handlePreviousMonth = () => {
    const newDate = new Date(selectedDate);
    newDate.setMonth(newDate.getMonth() - 1);
    onDateChange(newDate);
  };
  const handleNextMonth = () => {
    const newDate = new Date(selectedDate);
    newDate.setMonth(newDate.getMonth() + 1);
    onDateChange(newDate);
  };
  return <div className="relative" data-id="element-36">
      <button ref={buttonRef} onClick={() => setIsOpen(!isOpen)} aria-label="Select date" aria-expanded={isOpen} className="flex items-center text-gray-600 border border-gray-200 px-4 py-1.5 rounded-md text-sm mr-3 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-37">
        <CalendarIcon size={16} className="mr-2" data-id="element-38" />
        {formatDate(selectedDate)}
      </button>
      {isOpen && <div ref={datePickerRef} className="absolute mt-2 bg-white rounded-lg shadow-lg border border-gray-200 p-4 w-64 z-10" data-id="element-39">
          <div className="flex items-center justify-between mb-4" data-id="element-40">
            <button onClick={handlePreviousMonth} className="p-1 hover:bg-gray-100 rounded-full" aria-label="Previous month" data-id="element-41">
              <ChevronLeftIcon size={20} data-id="element-42" />
            </button>
            <span className="font-medium" data-id="element-43">{formatDate(selectedDate)}</span>
            <button onClick={handleNextMonth} className="p-1 hover:bg-gray-100 rounded-full" aria-label="Next month" data-id="element-44">
              <ChevronRightIcon size={20} data-id="element-45" />
            </button>
          </div>
          <div className="grid grid-cols-3 gap-2" data-id="element-46">
            {Array.from({
          length: 12
        }, (_, i) => {
          const date = new Date(selectedDate.getFullYear(), i, 1);
          return <button key={i} onClick={() => {
            onDateChange(date);
            setIsOpen(false);
          }} className={`py-2 px-3 text-sm rounded-md ${selectedDate.getMonth() === i ? 'bg-blue-50 text-blue-600' : 'hover:bg-gray-100'}`} data-id="element-47">
                    {date.toLocaleString('default', {
              month: 'short'
            })}
                  </button>;
        })}
          </div>
          <div className="mt-4 grid grid-cols-2 gap-2" data-id="element-48">
            <button onClick={() => {
          const newDate = new Date(selectedDate);
          newDate.setFullYear(newDate.getFullYear() - 1);
          onDateChange(newDate);
        }} className="py-2 px-3 text-sm rounded-md hover:bg-gray-100" data-id="element-49">
              {selectedDate.getFullYear() - 1}
            </button>
            <button onClick={() => {
          const newDate = new Date(selectedDate);
          newDate.setFullYear(newDate.getFullYear() + 1);
          onDateChange(newDate);
        }} className="py-2 px-3 text-sm rounded-md hover:bg-gray-100" data-id="element-50">
              {selectedDate.getFullYear() + 1}
            </button>
          </div>
        </div>}
    </div>;
};